import ProductVariant from '@/shared/types/products/productVariant.type';

const getVariantIdsByProductId = (variants: ProductVariant[]) => {
  const uniqueProductIds = [...new Set(variants.map((v) => v.product_id))];

  return uniqueProductIds.map((productId) => ({
    product_id: productId,
    variants: variants
      .filter((variant) => variant.product_id === productId)
      .map((variant) => variant.variant_id),
  }));
};

export default getVariantIdsByProductId;
